<div
  class="w-100"
  style="position: relative"
  [ngClass]="{ 'no-mouse': disabled }"
>
  <ngx-intl-tel-input
    matInput
    [cssClass]="
      phoneInput.touched &&
      !disabled &&
      (phoneInput.invalid || phoneInput.hasError('required'))
        ? 'error-phone-number-input'
        : 'phone-number-input'
    "
    [id]="dataTestId"
    [attr.data-testid]="dataTestId"
    [enableAutoCountrySelect]="true"
    [enablePlaceholder]="true"
    [searchCountryFlag]="true"
    [preferredCountries]="['lk']"
    [searchCountryField]="[SearchCountryField.All]"
    [selectFirstCountry]="true"
    [selectedCountryISO]="country"
    [maxLength]="15"
    [phoneValidation]="true"
    [separateDialCode]="true"
    [numberFormat]="phoneNumberFormat.International"
    name="phoneInput"
    [formControl]="phoneInput"
    [disabled]="disabled"
  >
  </ngx-intl-tel-input>
  @if (icon) {
  <mat-icon class="phone-field-icon" matSuffix>{{ icon }}</mat-icon>
  } @if ( hint && (!phoneInput.touched || (phoneInput.touched &&
  !phoneInput.invalid && !phoneInput.hasError('required'))) ) {
  <mat-hint class="neo-phone-number-input__error">{{ hint }}</mat-hint>
  } @if (phoneInput.touched && !disabled && phoneInput.hasError('required')) {
  <mat-error class="neo-phone-number-input__error">{{
    'setup.support.form.phone-number-required' | translate
  }}</mat-error>
  } @if ( phoneInput.touched && !disabled && phoneInput.invalid &&
  !phoneInput.hasError('required') ) {
  <mat-error class="neo-phone-number-input__error">{{
    'setup.support.form.phone-number-invalid' | translate
  }}</mat-error>
  }
</div>
